import { isRouteErrorResponse, useRouteError } from 'react-router';
import { Alert, Button, ButtonLink, PageHeader } from '../../components/ui';
import { PlainLayout } from '../layout/PlainLayout';

export function NotFoundPage() {
  return (
    <PlainLayout>
      <PageHeader title="Page not found" description="The address may be wrong, or the page may have moved." />
      <ButtonLink to="/">Go to the home page</ButtonLink>
    </PlainLayout>
  );
}

/** Route error boundary: chunk-load failures (after a deploy) and unexpected render errors. */
export function RouteErrorPage() {
  const error = useRouteError();
  const is404 = isRouteErrorResponse(error) && error.status === 404;
  if (is404) return <NotFoundPage />;
  const chunkFailed = error instanceof Error && /dynamically imported module|Importing a module script failed|Failed to fetch/i.test(error.message);
  return (
    <PlainLayout>
      <PageHeader title="Something went wrong" />
      <Alert
        tone="danger"
        title={chunkFailed ? 'A new version of Seventide is available' : 'This page could not be shown'}
        action={
          <>
            <Button onClick={() => window.location.reload()}>Reload the page</Button>
            <ButtonLink to="/" variant="secondary">
              Go to the home page
            </ButtonLink>
          </>
        }
      >
        {chunkFailed
          ? 'Reload the page to continue. Nothing you saved has been lost.'
          : 'Please reload the page. If it keeps happening, contact support. Nothing you saved has been lost.'}
      </Alert>
    </PlainLayout>
  );
}

/** Unknown path inside a workspace: keeps the shell (nav) visible. */
export function NotFoundInShell() {
  return (
    <PageHeader title="Page not found" description="The address may be wrong, or the page may have moved." />
  );
}
